import img1 from "./petrov-1.jpg";
import img2 from "./petrov-2.jpg";
import img3 from "./petrov-3.jpg";
import img4 from "./petrov-4.jpg";
import img5 from "./petrov-5.jpg";
import img6 from "./petrov-6.jpg";
import img7 from "./petrov-7.jpg";
import img8 from "./petrov-8.jpg";

export const petrovImages = [img1, img2, img3, img4, img5, img6, img7, img8];
